import React from "react";
import { Row } from "react-bootstrap";

import "./style.scss";

export const UniversityComments = ({ item }) => {
  return(
      <Row className="university-comments-about-program" tabIndex="0" 
      dangerouslySetInnerHTML={{ __html: item.field_comments, } } >
    </Row> 
  )
}